<template>
    <!--单据列表-单据详情-->
    <div class="check-receipt-detail">
        <Row type="flex" justify="space-between" align="middle">
            <div class="title-l">
                <router-link to="/index" class="span-box">
                    <Icon type="ios-arrow-back" />
                    <span>单据详情</span>
                </router-link>
            </div>
            <div>
                <Button type="primary" size="large" @click="quoteOrder">引用</Button>
                <span></span>
                <Button type="primary" size="large" :loading="loadingPrint" @click="printReceipt">打印</Button>
            </div>
        </Row>
        <div v-if="spinShow">
            <Spin size="large" fix style="top: 80px"></Spin>
        </div>
        <div id="Print-s">
            <div class="receipt-head-box">
                <div class="company-signature print-show">
                    <span>售卖单位（签章）：</span>
                    <span>采购单位（签章）：</span>
                    <span class="last-span">
                        年&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        月&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        日&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                </div>
                <div class="receipt-label">
                    单据信息
                </div>
                <div class="receipt-info">
                    <Row class="receipt-page-show">
                        <!-- <Col :span="8" v-for="(ele, index) in receiptInfo" :key="index"
                            :class="[!receiptInfoLabel.hasOwnProperty(index) ? 'dis-none' : '', index ? index : '']">
                            <span v-if="index === 'postAt' || index === 'acceptAt'">
                                {{ receiptInfoLabel[index] }}： {{ ele === 'Invalid date' ? '' : ele }}
                            </span>
                            <span v-if="index === 'originStatus'">
                                {{ receiptInfoLabel[index] }}： {{ ele === 1 ? '未生成' : '已生成' }}
                            </span>
                            <span v-if="index !== 'postAt' && index !== 'originStatus' && index !== 'acceptAt'">
                                {{ receiptInfoLabel[index] }}： {{ ele }}
                            </span>
                        </Col>
                        <Col :span="24">
                            <span>结算渠道： {{ receiptInfo.settleChannel }}</span>
                        </Col> -->
                        <!-- 新 -->
                        <Col :span="8" class="originNo">
                            <span>原始单号: {{receiptInfo.originNo}}</span>
                        </Col>
                        <Col :span="8" class="originStatus">
                            <span>原始单据状态: {{receiptInfo.originStatus === 1 ? '未生成' :  '已生成'}}</span>
                        </Col>
                        <Col :span="8" class="dataSource">
                            <span>数据源: {{receiptInfo.dataSource}}</span>
                        </Col>
                        <Col :span="8" class="organNo">
                            <span>采购单位编码: {{receiptInfo.organNo}}</span>
                        </Col>
                        <Col :span="16" class="path">
                            <span>采购单位名称: {{receiptInfo.path}}</span>
                        </Col>
                        <Col :span="8" class="supplierNo">
                            <span>供应商编码: {{receiptInfo.supplierNo}}</span>
                        </Col>
                        <Col :span="16" class="supplierName">
                            <span>供应商名称: {{receiptInfo.supplierName}}</span>
                        </Col>
                        <Col :span="8" class="settleChannel">
                            <span>结算渠道: {{receiptInfo.settleChannel}}</span>
                        </Col>
                        <Col :span="8" class="docNo">
                            <span>订单号: {{receiptInfo.docNo}}</span>
                        </Col>
                        <Col :span="8" class="orderStatus">
                            <span>订单状态: {{receiptInfo.orderStatus}}</span>
                        </Col>
                        <Col :span="8" class="submitAt">
                            <span>提交时间: {{receiptInfo.submitAt}}</span>
                        </Col>
                        <Col :span="8" class="createdAt">
                            <span>创建时间: {{receiptInfo.createdAt}}</span>
                        </Col>
                        <Col :span="8" class="updatedAt">
                            <span>修改时间: {{receiptInfo.updatedAt}}</span>
                        </Col>
                        <Col :span="8" class="postAt">
                            <span>过账时间: {{receiptInfo.postAt === 'Invalid date' ? '' : receiptInfo.postAt}}</span>
                        </Col>
                        <Col :span="8" class="ladingBill">
                            <span>提单人员: {{receiptInfo.ladingBill}}</span>
                        </Col>
                        <Col :span="8" class="ladingBillName">
                            <span>提单人: {{receiptInfo.ladingBillName}}</span>
                        </Col>
                        <Col :span="8" class="acceptNo">
                            <span>验收人员: {{receiptInfo.acceptNo}}</span>
                        </Col>
                        <Col :span="8" class="acceptName">
                            <span>验收人: {{receiptInfo.acceptName}}</span>
                        </Col>
                        <Col :span="8" class="acceptAt">
                            <span>验收时间: {{receiptInfo.acceptAt === 'Invalid date' ? '' : receiptInfo.acceptAt}}</span>
                        </Col>
                        <Col :span="8" class="projectId" v-if="projectStatus === '1'">
                            <span>计划单号: {{receiptInfo.projectId}}</span>
                        </Col>
                        <Col :span="8" class="projectId" v-if="projectStatus !== '1' && quotationStatus === '1'">
                            <span>询价单: {{receiptInfo.quotationNo}}</span>
                        </Col>
                        <Col :span="16" class="abstract" v-if="projectStatus === '1'">
                            <span>备注: {{receiptInfo.abstract}}</span>
                        </Col>
                    </Row>
                    <!-- 打印 -->
                    <Row class="receipt-print-show">
                        <Col :span="8" class="originNo">
                            <span>原始单号: {{receiptInfo.originNo}}</span>
                        </Col>
                        <Col :span="8" class="submitAt">
                            <span>提交时间: {{receiptInfo.submitAt}}</span>
                        </Col>
                        <Col :span="8" class="dataSource">
                            <span>数据源: {{receiptInfo.dataSource}}</span>
                        </Col>
                        <Col :span="8" class="organNo">
                            <span>采购单位编码: {{receiptInfo.organNo}}</span>
                        </Col>
                        <Col :span="16" class="path">
                            <span>采购单位名称: {{receiptInfo.path}}</span>
                        </Col>
                        <Col :span="8" class="supplierNo">
                            <span>供应商编码: {{receiptInfo.supplierNo}}</span>
                        </Col>
                        <Col :span="8" class="supplierName">
                            <span>供应商名称: {{receiptInfo.supplierName}}</span>
                        </Col>
                        <Col :span="8" class="settleChannel">
                            <span>结算渠道: {{receiptInfo.settleChannel}}</span>
                        </Col>
                        <Col :span="8" class="createdAt">
                            <span>创建时间: {{receiptInfo.createdAt}}</span>
                        </Col>
                        <Col :span="16" class="updatedAt">
                            <span>修改时间: {{receiptInfo.updatedAt}}</span>
                        </Col>
                        <Col :span="8" class="projectId" v-if="projectStatus === '1'">
                            <span>计划单号: {{receiptInfo.projectId}}</span>
                        </Col>
                        <Col :span="16" class="abstract" v-if="projectStatus === '1'">
                            <span>备注: {{receiptInfo.abstract}}</span>
                        </Col>
                    </Row>
                </div>
            </div>
            <table width="100%" border="1" cellspacing="1" cellpadding="1" class="y-table">
                <thead align="center">
                    <tr>
                        <th>行项目</th>
                        <th>SPU码</th>
                        <th style="width: 120px">物资名称</th>
                        <th>物资类编码</th>
                        <th>类别名称</th>
                        <th>物资规格</th>
                        <th>计量单位</th>
                        <th>数量</th>
                        <th>单价（元）</th>
                        <th>金额（元）</th>
                    </tr>
                </thead>
                <tbody align="center">
                    <tr v-for="(item, index) in receiptData" :key="index">
                        <td>{{item.serialNum}}</td>
                        <td>{{item.spu}}</td>
                        <td>{{item.productName}}</td>
                        <td>{{item.classifyNo}}</td>
                        <td>{{item.classifyName}}</td>
                        <td>{{item.productSpectype}}</td>
                        <td>{{item.productSpec}}</td>
                        <td>{{item.productCount}}</td>
                        <td>{{item.unitPrice}}</td>
                        <td>{{item.totalPrice}}</td>
                    </tr>
                </tbody>
            </table>
            <Row class="table-footer-box" type="flex" justify="end">
                <div class="monry-detail-info">
                    <span>
                        共： <b class="weight"> {{ receiptInfo.originalItemsCount || 0 }} </b>项
                    </span>
                    <span>
                        数量合计： <b class="weight"> {{ receiptInfo.productCount || 0 }} </b>
                    </span>
                    <span>
                        金额合计： <b class="weight"> ￥{{ receiptInfo.orderAmount || 0 }}元 </b>
                    </span>
                </div>
            </Row>
            <div class="company-signature-footer print-show">
                <p>
                    售卖人：<span></span>
                </p>
                 <p>
                    采购人：<span></span><span></span>
                </p>
                 <p>
                    验收人：
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import printJS from 'print-js';
import { getOriginalByOriginNo } from '@/graphql/graphql.js';
import Cookies from 'js-cookie';
export default {
    data() {
        return {
            // table 头部定义
            // serialNum 行号
            loading: false,
            loadingPrint: false,
            modalPrint: false,
            columns: [
                {
                    title: '行项目',
                    key: 'serialNum',
                    minWidth: 80,
                    className: 'serialNum'
                },
                {
                    title: 'SPU码',
                    key: 'spu',
                    minWidth: 100,
                    className: 'spu'
                },
                {
                    title: '物资名称',
                    key: 'productName',
                    minWidth: 100,
                    className: 'productName'
                },
                {
                    title: '物资类编码',
                    key: 'classifyNo',
                    minWidth: 100,
                    className: 'classifyNo'
                },
                {
                    title: '类别名称',
                    key: 'classifyName',
                    minWidth: 100,
                    className: 'classifyName'
                },
                {
                    title: '物资规格',
                    key: 'productSpectype',
                    minWidth: 100,
                    className: 'productSpectype'
                },
                {
                    title: '计量单位',
                    key: 'productUnit',
                    minWidth: 100,
                    className: 'productUnit'

                },
                {
                    title: '数量',
                    key: 'productCount',
                    minWidth: 100,
                    className: 'productCount'
                },
                {
                    title: '单价（元）',
                    key: 'unitPrice',
                    minWidth: 100,
                    className: 'unitPrice'
                },
                {
                    title: '金额（元）',
                    key: 'totalPrice',
                    minWidth: 100,
                    className: 'totalPrice'
                }
            ],

            // table 数据部分
            receiptData: [],

            // 表头定义
            receiptInfoLabel: {
                originNo: '原始单号',
                docNo: '订单号',
                orderStatus: '订单状态',
                path: '采购单位',
                organNo: '采购单位编码',
                supplierName: '供应商名称',
                supplierNo: '供应商编码',
                originStatus: '原始单据状态',
                submitAt: '提交时间',
                createdAt: '创建时间',
                updatedAt: '修改时间',
                postAt: '过账时间',
                ladingBill: '提单人员',
                ladingBillName: '提单人',
                acceptNo: '验收人员',
                acceptName: '验收人',
                acceptAt: '验收时间',
                dataSource: '数据源'
            },

            // 单据信息
            receiptInfo: {},

            printJsOption: {
                printable: 'Print-s',
                type: 'html',
                header: '食材销售(入库)清单',
                maxWidth: 1060,
                headerStyle: 'font-size: 30px;color: #000;text-align: center;width: 100%; background: #fff;',
                css: 'static/css/print.css',
                font_size: '18pt',
                targetStyles: ['*']
            },
            spinShow: false,
            projectStatus: '',
            quotationStatus: '',
            timerId: null
        };
    },

    mounted() {
        if (this.$route.query.origin) {
            this.getOriginReceiptDetail();
        } else {
            this.$setNotice('请选择详情');
            this.$router.push('/index');
        }
        const supplierFun = JSON.parse(window.localStorage.getItem('supplierFunction'));
        this.projectStatus = supplierFun.project1 > -1 ? '1' : '0';
        this.quotationStatus = supplierFun.quotation > -1 ? '1' : '0';
    },
    beforeDestroy() {
        if (this.timerId) {
            clearTimeout(this.timerId);
        }
    },
    methods: {
        // 打印按钮
        printReceipt() {
            this.loadingPrint = true;
            this.timerId = setTimeout(() => {
                printJS(this.printJsOption);
                this.loadingPrint = false;
            }, 2000);
        },
        // 根据原始单号查看单据详情
        getOriginReceiptDetail() {
            this.spinShow = true;
            const clique = Cookies.getJSON('cliqueNo');
            this.$apollo.query({
                query: getOriginalByOriginNo,
                variables: {
                    cliqueNo: clique.toString(),
                    originNo: this.$route.query.origin
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                this.spinShow = false;
                const data = res.data.getOriginalByOriginNo;
                if (data && data.code === 200) {
                    this.receiptInfo = data.data;
                    this.receiptData = data.data.items;
                } else {
                    this.$setNotice('详情获取失败,请重新选择');
                }
            });
        },

        // 引用当前单据创建模板
        quoteOrder() {
            this.$router.push({
                path: '/index/modelBuild',
                query: {
                    origin: this.$route.query.origin,
                    projectId: this.receiptInfo.projectId
                }
            });
        }
    }
};
</script>

<style lang="stylus">

@import '../assets/stylus/views/receipt-detail.styl'

</style>



// WEBPACK FOOTER //
// src/views/CheckReceiptDetail.vue